const browserCompat = () => {
  let hidden = 'hidden';
  let visibilityChange = 'visibilitychange';

  if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  return {
    hidden,
    visibilityChange,
  };
};

export default ({ onHidden = () => {}, onVisible = () => {} } = {}) => {
  const { hidden, visibilityChange } = browserCompat();

  if (typeof document[hidden] === 'undefined') {
    return null;
  }

  const handler = () => {
    if (document[hidden]) {
      onHidden();
    } else {
      onVisible();
    }
  };

  document.addEventListener(visibilityChange, handler);

  return handler;
};
